<highcharts-chart
  class="chart highcharts-light"
  [options]="chartOptions()"
/>
